import { render } from "./Services6.vue?vue&type=template&id=8a416c1a&scoped=true"
import script from "./Services6.vue?vue&type=script&lang=js"
export * from "./Services6.vue?vue&type=script&lang=js"

import "./Services6.vue?vue&type=style&index=0&id=8a416c1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a416c1a"]])

export default __exports__